export const RegistrationResponse = () => {
    let info = {
        GuestUID: "",
        EventID: "",
        Response : "",
        ResponsedDate : "",
        RegistrationInfo: "",
        FirstName: "",
        LastName: "",
        Email: "",
        AdditionalGuest: 0
    };
    return info;
}

export const RegistrationInfo = () => {
    let info = {
        DeclineComment: "",
        AdditionalGuests: null,
        OriginalGuestUID: ""
    };
    return info;
}

export const UnsubscribeInfo = () => {
    let info = {
        Email: "",
        ResponsedDate: ""
    };
    return info;
}